import { render, staticRenderFns } from "./personalMobil.vue?vue&type=template&id=6f9ba2ba&"
import script from "./personalMobil.vue?vue&type=script&lang=ts&"
export * from "./personalMobil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports